import { EntityType } from "../../api/grpc/subscription/subscription";
import { PRODUCT_STORE_SECTIONS } from "./ProductStore.catalog";
import { ProductStorePricing } from "./ProductStore.types";
import { resolveProductPrice } from "./productStorePrices";

/** A subscription add-on the customer can buy through checkout. */
export interface SubscriptionAddOn {
  id: string;
  title: string;
  entityType: EntityType;
  /** For the subscription's currency and term. */
  priceId: string;
}

/**
 * The add-on a `subscription` action's price ID belongs to, or undefined when
 * it isn't one the customer can buy (e.g. no longer priced for their term).
 */
export const findSubscriptionAddOn = (
  priceId: string,
  { prices, term }: ProductStorePricing
): SubscriptionAddOn | undefined =>
  PRODUCT_STORE_SECTIONS.flatMap((section) => section.products).flatMap(
    (product) => {
      const resolved =
        product.action.type === "subscription"
          ? resolveProductPrice(product.pricing, prices, term)
          : undefined;

      return resolved?.priceId === priceId && product.entityType !== undefined
        ? [
            {
              id: product.id,
              title: product.title,
              entityType: product.entityType,
              priceId,
            },
          ]
        : [];
    }
  )[0];
